import { render, staticRenderFns } from "./manage-registration.vue?vue&type=template&id=2aa8354a&scoped=true&"
import script from "./manage-registration.vue?vue&type=script&lang=js&"
export * from "./manage-registration.vue?vue&type=script&lang=js&"
import style0 from "./manage-registration.vue?vue&type=style&index=0&id=2aa8354a&scoped=true&lang=scss&"
import style1 from "./manage-registration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8354a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa8354a')) {
      api.createRecord('2aa8354a', component.options)
    } else {
      api.reload('2aa8354a', component.options)
    }
    module.hot.accept("./manage-registration.vue?vue&type=template&id=2aa8354a&scoped=true&", function () {
      api.rerender('2aa8354a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/manage-registration.vue"
export default component.exports